// extracted by mini-css-extract-plugin
export var active = "WishlistButton-module--active--fc4dd";
export var mps_button = "WishlistButton-module--mps_button--f4425";
export var wishlist = "WishlistButton-module--wishlist--0b9f1";